import { render, staticRenderFns } from "./CuratedItems.vue?vue&type=template&id=3d8a2ba2&scoped=true&"
import script from "./CuratedItems.vue?vue&type=script&lang=js&"
export * from "./CuratedItems.vue?vue&type=script&lang=js&"
import style0 from "./CuratedItems.vue?vue&type=style&index=0&id=3d8a2ba2&prod&lang=scss&scoped=true&"
import style1 from "./CuratedItems.vue?vue&type=style&index=1&id=3d8a2ba2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a2ba2",
  null
  
)

export default component.exports